<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-introduction element-without-heading" id="introduction">
<div class="text" id="introduction-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>Don’t miss book three of the Fey Matter series with <a class="content-external-link" href="https://smarturl.it/BarrowCO" target="_blank"><span class="underline">BARROW WITCH</span></a> and find more from Craig Comer at <a class="content-external-link text-is-url" href="http://www.craigcomer.com" target="_blank">www.craigcomer.com</a></b></p>
</div>
</div>
<div class="inline-image inline-image-kind-photograph inline-image-size-medium inline-image-flow-right inline-image-flow-within-text inline-image-aspect-tall inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<a class="link-contains-image" href="https://smarturl.it/BarrowCO" target="_blank">
<img alt="Barrow Witch cover" src="images/barrow-digital-cover.jpg"/>
</a>
</div>
</div>
<p class="first first-in-chapter"><b>With a treaty to bring peace to the Scottish fey hanging in the balance, Effie of Glen Coe must claim her place as the heart of the Seily Court, if she is to defeat the dark madness of the Barrow Witch.</b></p>
<p class="subsq">The treaty that will bring peace to the fey of Scotland is within Effie of Glen Coe’s grasp. Yet the lords of London will not consent to such an accord until the madness spreading across the empire is halted, and its source destroyed.</p>
<p class="subsq">As Effie and her allies hunt for the ancient being known as the Barrow Witch, they uncover her sinister plot. The Barrow Witch has found an alchemic means to transform fey into devilish creatures bent on her will. Using these marauding bands, she seeks to enslave not only the empire, but all of fey kind.</p>
<p class="subsq">Effie’s fight takes her from haunted cities to ruined castles, but it is not until Caledon, Steward of the Seily Court, is captured that she must finally confront her own self-doubts, and the legacy of her family’s treacherous past. For only by accepting she has become the very heart of the Scottish fey, can she learn to unravel the schemes of their enemy and rally the empires of man and fey toward an ultimate confrontation with the Barrow Witch.</p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="https://smarturl.it/BarrowCO" target="_blank"><b><span class="underline">BUY NOW!</span></b></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// keepreadingthefeymatterseries.vue?c52218d4